export const tableColumns = [
    
    {
        name: 'Event ID',
        selector: row => row.event_id,
        sortable: true,
        center: true,
        minWidth: '9.375rem',
        cell: row => (
            <span style={{ 
                color: '#5C61F2', 
                fontWeight: 'bold'
            }}>
                {row.event_id}
            </span>
        ),
    },
    {
        name: 'Event Name',
        selector: row => row.event_name,
        sortable: true,
        center: true,
        minWidth: '15rem',
        
    },

    {
        name: 'Author',
        selector: row => row.author,
        sortable: true,
        center: true,
        minWidth: '9.375rem',
    },
    {
        name: 'Event Date',
        selector: row => row.eventDate,
        sortable: true,
        center: true,
        minWidth: '9.375rem',
    },
    {
        name: 'Submitted Date',
        selector: row => row.submittedDate,
        sortable: true,
        center: true,
        minWidth: '9.375rem',
    },
    {
        name: 'Updated by',
        selector: row => row.updatedBy,
        sortable: true,
        center: true,
        minWidth: '9.375rem',
    },
    {
        name: 'Updated On',
        selector: row => row.updatedOn,
        sortable: true,
        center: true,
        minWidth: '9.375rem',
    },
    {
        name: 'Status',
        selector: row => row.status,
        sortable: true,
        center: true,
        minWidth: '6.25rem',
    },
    {
        name: 'Action',
        selector: row => row.action,
        sortable: false,
        center: true,
        minWidth: '10rem',
    },
];